import { render, staticRenderFns } from "./intelligentControl.vue?vue&type=template&id=c987768c&scoped=true"
import script from "./intelligentControl.vue?vue&type=script&lang=js"
export * from "./intelligentControl.vue?vue&type=script&lang=js"
import style0 from "./intelligentControl.vue?vue&type=style&index=0&id=c987768c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c987768c",
  null
  
)

export default component.exports